import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { ToggleSearch } from './components/ToggleSearch';
import { SearchInput } from './components/SearchInput';
import { SearchResultContainer } from './components/SearchResultContainer';

import { FETCH_SEARCH_RESULTS } from '../../../../store/js/modules/statspro/search/actions';

export const Search = ({ compseason }) => {

    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [focused, setFocused] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    const selectSearchResults = createSelector(
        state => state.statspro.searchResults?.players,
        players => players
    );
    
    const results = useSelector(selectSearchResults);

    const onSearchSubmit = async query => {
        dispatch( FETCH_SEARCH_RESULTS.request( { compseason, query } ) );
        setIsLoading(true);
    }

    const toggleActive = () => {
        if (isActive) {
            setIsActive(false);
            setFocused(false);
        } else {
            setIsActive(true);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => setQuery(debouncedQuery.trim()), 1000);
        return () => clearTimeout(timer);
    }, [debouncedQuery]);

    useEffect(() => {
        if (query !== '' && query.length > 2) {
            onSearchSubmit(query);
        }
    }, [query]);

    useEffect(() => {
       if (isLoading) {
           setIsLoading(false);
       }
    }, [results]);

    const useOutsideChecker = ref => {
        useEffect(() => {
            function handleClickOutside(event) {
                if ( ( event.type === 'keyup' && event.keyCode === 9 ) || event.type === 'mousedown' ) {
                    if (ref.current && !ref.current.contains(event.target)) {
                        setFocused(false);
                    } else {
                        setFocused(true);
                    }
                }
            }
            // Bind the event listeners
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("keyup", handleClickOutside);
            return () => {
                // Unbind the event listeners on clean up
                document.removeEventListener("mousedown", handleClickOutside);
                document.removeEventListener("keyup", handleClickOutside);
            };
        }, [ref]);
    }

    const searchRef = useRef(null);
    useOutsideChecker(searchRef);

    return (
        <div className='stats-search' ref={ searchRef }>

            {/* Mobile display */}
            <ToggleSearch onClick={ toggleActive } />

            <SearchInput setDebouncedQuery={ setDebouncedQuery } isActive={ isActive } onClick={ toggleActive } />
           
            {( query.length > 2 ) &&
                <SearchResultContainer isLoading={ isLoading } focused={ focused } query={ query } results={ results } />
            }
        </div>
    );
}

Search.propTypes = {
    compseason: PropTypes.string.isRequired
};

